<template>
  <FlotoDrawerForm
    :open="isFeedbackDrawerOpen"
    @cancel="handleFeedbackDrawer"
    @hide="handleFeedbackDrawer"
    @submit="handleSubmit"
  >
    <template v-slot:header>
      {{ resource.name }}: {{ resource.subject }}
      <div>
        <small class="text-neutral">
          {{ resource.createdAt | datetime }}
        </small>
      </div>
    </template>
    <template v-if="resource.description">
      <FlotoReadMore>
        <FlotoRichEditor :value="resource.description" disabled />
      </FlotoReadMore>
    </template>
    <MDivider v-if="resource.description" />

    <FlotoFormItem>
      <FlotoContentLoader :loading="loading">
        <FormConsumer
          v-if="customFields.length"
          v-model="data"
          :form-fields="customFields"
          :with-submit="false"
        >
          <!-- <template v-slot:submit>
            <MButton id="send-btn" type="submit" :loading="processing">
              <slot name="submit-text">{{ $t('send') }}</slot>
            </MButton>
          </template> -->
          <template v-slot:reset>
            <span />
          </template>
        </FormConsumer>
      </FlotoContentLoader>
    </FlotoFormItem>
    <template v-slot:actions="{ submit, hide }">
      <MButton id="send-btn" :loading="processing" @click="submit">
        <slot name="submit-text">{{ $t('send') }}</slot>
      </MButton>
      <MButton id="cancel-btn" variant="default" class="ml-2" @click="hide">
        {{ $t('cancel') }}
      </MButton>
    </template>
  </FlotoDrawerForm>
</template>

<script>
import FormConsumer from '@components/form-consumer.vue'
import { getFeedbackForm, sendFeedbackForm } from '../support-portal-api'

export default {
  name: 'FeedbackFormDrawer',
  components: {
    FormConsumer,
  },
  props: {
    resource: { type: Object, required: true },
    isFeedbackDrawerOpen: { type: Boolean, required: true },
  },
  data() {
    return {
      loading: true,
      processing: false,
      data: {
        rating: 3,
      },
      customFields: [],
    }
  },

  created() {
    getFeedbackForm()
      .then((form) => {
        this.customFields = form.fields || []
      })
      .finally(() => (this.loading = false))
  },
  methods: {
    handleFeedbackDrawer() {
      this.$emit('handleFeedbackDrawer')
    },
    handleSubmit() {
      this.processing = true

      sendFeedbackForm(this.resource.id, this.data)
        .then(() => {
          this.$successNotification({
            message: this.$t('thank_you_feedback'),
          })
          this.$emit('done')
        })
        .finally(() => {
          this.processing = false
          this.handleFeedbackDrawer()
        })
    },
  },
}
</script>
